import { render, staticRenderFns } from "./corpList.vue?vue&type=template&id=4d471fbd&scoped=true&"
import script from "./corpList.vue?vue&type=script&lang=js&"
export * from "./corpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d471fbd",
  null
  
)

export default component.exports